// extracted by mini-css-extract-plugin
module.exports = {"container":"DLS_F3vdZwEekax4OdUfI","icon":"_1u1dPI--HjxBYgmppmhVO0"};